import EditorialLayout, { editorialStyles as styles } from '../components/EditorialLayout'

export default function About() {
  return (
    <EditorialLayout
      title='About Guitar-Tuner.org'
      description='Guitar-Tuner.org is a free browser-based tuning resource for acoustic guitar, electric guitar, bass, and ukulele.'
      path='/about'
      eyebrow='About us'
    >
      <h2>A practical tuner, available when you need it</h2>
      <p>
        Guitar-Tuner.org was created to make routine instrument tuning simple.
        You can use a microphone for automatic pitch detection or play reference
        notes and tune by ear. The tuner supports acoustic guitar, electric
        guitar, bass, ukulele, and a growing selection of alternate tunings.
      </p>
      <p>
        The automatic tuner processes microphone audio locally in your browser.
        The audio used for pitch detection is not recorded, uploaded, or stored
        by Guitar-Tuner.org.
      </p>

      <div className={styles.callout}>
        <p>
          <strong>Our goal:</strong> combine a fast everyday tool with clear,
          technically accurate explanations that help musicians understand what
          the tuner is showing them.
        </p>
      </div>

      <h2>How we prepare our guides</h2>
      <p>
        Our tuning guides are written around practical questions musicians face:
        which frequency belongs to a string, why an instrument drifts out of
        tune, and how a browser can recognise pitch. Frequency tables use
        twelve-tone equal temperament with A4 set to 440 Hz unless a guide says
        otherwise.
      </p>
      <p>
        We aim to distinguish measurable facts from practical recommendations,
        include examples where they improve understanding, and review technical
        details when the tuner changes. Every guide displays its latest review
        date.
      </p>

      <h2>Who operates the website?</h2>
      <p>
        Guitar-Tuner.org is operated by <strong>ChordChord OÜ</strong>, Sepapaja
        6, Tallinn 15551, Estonia. Questions, corrections, and feedback are
        welcome at{' '}
        <a href='mailto:team@guitar-tuner.org'>team@guitar-tuner.org</a>.
      </p>

      <h2>Start tuning or learning</h2>
      <p>
        Open the <a href='/'>online tuner</a>, choose a dedicated{' '}
        <a href='/acoustic-guitar-tuning'>acoustic guitar tuner</a>, or visit
        our <a href='/guides'>tuning guides</a> to understand the notes and
        numbers behind accurate tuning.
      </p>
    </EditorialLayout>
  )
}
